import WatchList from "../../../components/watch-list/watch-list";
import Page from "../../page";

const WatchListPage = () => {
  return (
    <Page>
      <WatchList />
    </Page>
  );
};

export default WatchListPage;
